<template>
  <div class="news-all">
    <div class="title">
      <span class="time">
        12.04
        <br />2017
      </span>
      <span class="tiel">第四届世界互联网大会美菜网刘传军: 流通，是实现精准扶贫的关键</span>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        12月3日至5日，第四届世界互联网大会•乌镇峰会在乌镇召开。美菜网作为农产品B2B领域受邀企业中规模最大、发展最快的互联网企业代表第三次受邀，亮相第四届世界互联网大会“互联网之光”博览会，向全球展示了美菜的脱贫主义，并以互联网企业服务生态诠释如何助力中小企业成长发展。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a9_11.jpg" width="640" />
      </p>
    </div>
    <div class="mat-content">
      <div class="tet-js">
        与往届相比，今年乌镇大会将一号馆设置为“新兴独角兽馆”，ofo、摩拜单车、旷视等一批成长性良好的初创企业聚集在此，美菜网在第二展位，刚进入展厅，美菜网的展台可尽收眼底，“美菜脱贫主义”引人注目，大屏幕上也播放着美菜的公益视频，可以清楚了解美菜网通过自建仓储、物流、配送，创新升级农产品供应链，砍掉所有的中间环节，实现农户和餐厅的直接交付。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a9_12.jpg" width="640" />
      </p>
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜网创始人、CEO刘传军参加共享红利：互联网精准扶贫论坛
      </div>
      <div class="tet-js">
        4日上午，美菜网创始人、CEO刘传军在第四届世界互联网大会共享红利：互联网精准扶贫的分论坛上发言，分享美菜网的成长故事和中国农产品电商的智慧之光！
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a9_05.jpg" width="640" />
      </p>
      <div class="tet-js">
        作为农产品B2B企业的代表，美菜网创始人刘传军在现场对话对话中国三星副总裁、AT&T副总裁、蒙牛CEO等人，一同探讨拓展农村互联网应用，响应精准扶贫号召，增强贫困地区发展等问题，扎实推进精准扶贫的工作。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a9_04.jpg" width="640" />
      </p>
      <br />
      <br />
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜网作为精准扶贫的践行者，采取了很多行动
      </div>
      <div class="tet-js">
        美菜网不但实施了扶贫菜助销计划，还计划进一步下沉供应链，大力拓展农产品源头布局，在农村建设农产品基地，并重点向贫困地区倾斜。为贫困地区打造更为畅通的农产品流通体系，将流通这汪活水注入到贫困地区，让贫困地区的资源真正流动起来，实现真脱贫。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a9_06.jpg" width="640" />
      </p>
      <div class="tet-js">
        扶贫更需扶智，输血更要造血。在美菜公司成立两周年之际，其依托中国红十字基金会设立了“最美菜公益基金”，两年多来，美菜网已经开展了小候鸟关爱计划、最美教室、最美包裹、最美扶贫公开课等项目，为农村留守儿童送去温暖，为贫困农村摆脱困境带去了光明。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a9_07.jpg" width="640" />
      </p>
      <br />
      <br />
    </div>
    <div class="mat-content">
      <div class="title-bold">
        <span></span>美菜脱贫主义：农产品上行的速度与激情
      </div>
      <div class="tet-js">
        美菜的脱贫主义，是美菜网建立的扶贫理论及实践体系。它通过农产品上行，以产业化的模式，解决农民卖菜难的问题；它创立信息化平台，解决农商之间的信息不对称的问题；它自建仓储、物流体系，解决农产品流通高损耗、低效能的问题；它通过需求侧对食品要求的升级、城市新零售的升级，解决订单农业、品质农产品、食品安全的问题；它以精准的行动，解决农产品供应链上农村儿童和留守儿童的教育问题、情感问题。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a9_08.jpg" width="640" />
      </p>
      <div class="tet-js">
        为贯彻落实国家精准扶贫战略，加快脱贫步伐，探索政企合作的扶贫新路子，在本次扶贫论坛中，美菜网与深度贫困地区内蒙古科尔沁右翼中旗、陕西省山阳县进行了现场签约，开展结对帮扶，真正助力农产品上行，为脱贫攻坚贡献一份力量。
        <br />
        <br />
      </div>
      <p align="center">
        <img src="@/assets/images/new-img/a9_09.jpg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜网创始人、CEO刘传军与科右中旗签约合作</div>
      <br />
      <br />
      <p align="center">
        <img src="@/assets/images/new-img/a9_10.jpg" width="640" />
      </p>
      <div class="tet-js" style="text-align: center">美菜网创始人、CEO刘传军与陕西省山阳县签约合作</div>
      <div
        class="tet-js"
      >美菜网创始人、CEO刘传军在共享红利：互联网精准扶贫的分论坛上讲道：“流通，是实现精准扶贫的必由之路。由于贫困地区基础设施弱、信息闭塞，农产品常常是种的出、运不走、没销路、卖不掉。因此，构建畅通的农产品流通体系，促进农产品上行，是实现“脱真贫、真脱贫”的关键要素之一。”</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "new-a1"
};
</script>

<style lang="scss" scoped>
</style>
